export class ChangePasswordFormModel {
  constructor(data = {}) {
    this.oldPassword = data?.oldPassword || "";
    this.password = data?.password || "";
    this.passwordConfirmation = data?.passwordConfirmation || "";
  }
}
